module.exports = __webpack_public_path__ + "static/media/installation outcome side 2.791a4821.png";